module.exports = __webpack_public_path__ + "img/app-store.3bb2dd96.svg";